import { walletConnectProvider } from "@/lazy-polkahub"
import { state } from "@react-rxjs/core"
import { type TxCreator, type SS58String } from "polkadot-api"
import {
  createLedgerProvider,
  createPjsWalletProvider,
  createPolkadotVaultProvider,
  createReadOnlyProvider,
  createSelectedAccountPlugin,
} from "polkahub"
import { combineLatest, map, switchMap } from "rxjs"
import { getNetworkInfo, stakingSdk$ } from "./chain"
import { USE_CHOPSTICKS } from "./chainConfig"

const selectedAccountPlugin = createSelectedAccountPlugin()
const pjsWalletProvider = createPjsWalletProvider({
  accountFormat: "ss58",
})
const polkadotVaultProvider = createPolkadotVaultProvider({
  getNetworkInfo,
})
const readOnlyProvider = createReadOnlyProvider({
  fakeSigner: USE_CHOPSTICKS,
})
const ledgerAccountProvider = createLedgerProvider(async () => {
  const module = await import("@ledgerhq/hw-transport-webusb")
  return module.default.create()
}, getNetworkInfo)

export const accountProviderPlugins = [
  selectedAccountPlugin,
  pjsWalletProvider,
  polkadotVaultProvider,
  readOnlyProvider,
  ledgerAccountProvider,
  walletConnectProvider,
]

export type SignerAccount = {
  address: SS58String
  polkadotSigner: TxCreator
}
export const selectedSignerAccount$ =
  selectedAccountPlugin.selectedAccount$.pipeState(
    map((v): SignerAccount | null => {
      if (!v?.txCreator) return null

      return {
        address: v.address,
        polkadotSigner: v.txCreator,
      }
    }),
  )

export const selectedAccountAddr$ =
  selectedAccountPlugin.selectedAccount$.pipeState(
    map((v): SS58String | null => v?.address ?? null),
  )

export const accountStatus$ = state(
  combineLatest([stakingSdk$, selectedAccountPlugin.selectedAccount$]).pipe(
    switchMap(([sdk, account]) => {
      if (!account) return [null]

      return sdk.getAccountStatus$(account.address)
    }),
  ),
)
